<!--
  --
  -- 現地支払 コンテンツコンポーネント
  --
  -->
<template>
  <v-list-item-content class="h-16">
    <v-list-item-title class="font-weight-bold">現地支払</v-list-item-title>
  </v-list-item-content>
</template>

<script>
export default {
  name: 'CContentCard',
  props: {
    pay: {
      type: Object,
      required: true
    }
  }
}
</script>
